'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.ModalBody.id = 'ModalBody';
Object.defineProperty(exports, 'ModalBody', {
  enumerable: true,
  get: function () {
    return react.ModalBody;
  }
});